// -----------------------------------------------------------------------------
// ICONS — Material Icons, outlined (round 31 #7, Kyle 01/Nov/26): every icon in the app comes from material.ts
// (generated from boards/icons/*.svg, the same files the boards use).
//   <Icon name="delete" />            inline, 1.15em, follows the text colour (buttons, menus, chips)
//   <Icon name="delete" size={18} />  fixed size (sidebar, toolbars)
//   ICONS[key]                        the sidebar's named icons (key kept from v0.2 so Shell / modules stay unchanged)
// -----------------------------------------------------------------------------
import type { ReactElement } from "react";
import { MATERIAL, type IconName } from "./material";

export type { IconName };

/** One Material icon. aria-hidden: the button or link around it carries the name (aria-label / its text). */
export function Icon({ name, size, className }: { name: IconName; size?: number; className?: string }) {
  const s = size ? `${size}px` : "1.15em";
  return (
    <svg className={`mi${className ? " " + className : ""}`} data-mi={name} width={s} height={s} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: MATERIAL[name] }} />
  );
}

const nav = (name: IconName) => <Icon name={name} size={18} />;
/** Sidebar icons by their v0.2 keys (Shell NavItem / NavIcon, modules/registry). Activity = timeline (Kyle 01/Nov/26). */
export const ICONS: Record<string, ReactElement> = {
  home: nav("home"),
  dashboard: nav("dashboard"),
  issues: nav("assignment"),
  progress: nav("bar_chart"),
  activity: nav("timeline"),
  admin: nav("admin_panel_settings"),
  setup: nav("display_settings"),
  history: nav("history"),
  notifications: nav("notifications"),
};
